import api from '../axios';

export async function listarMinisterios() {
  const res = await api.get('/ministerios/');
  return res.data;
}

export async function criarMinisterio(data) {
  const res = await api.post('/ministerios/', data);
  return res.data;
}

export async function atualizarMinisterio(id, data) {
  const res = await api.put(`/ministerios/${id}`, data);
  return res.data;
}

export async function deletarMinisterio(id) {
  const res = await api.delete(`/ministerios/${id}`);
  return res.data;
}

export async function listarCursos(params) {
  const res = await api.get('/cursos/', { params });
  return res.data;
}

export async function criarCurso(data) {
  const res = await api.post('/cursos/', data);
  return res.data;
}

export async function getCurso(id) {
  const res = await api.get(`/cursos/${id}`);
  return res.data;
}

export async function atualizarCurso(id, data) {
  const res = await api.put(`/cursos/${id}`, data);
  return res.data;
}

export async function deletarCurso(id) {
  const res = await api.delete(`/cursos/${id}`);
  return res.data;
}

export async function adicionarLider(cursoId, membroId) {
  const res = await api.post(`/cursos/${cursoId}/lideres`, { membro_id: membroId });
  return res.data;
}

export async function removerLider(cursoId, liderId) {
  const res = await api.delete(`/cursos/${cursoId}/lideres/${liderId}`);
  return res.data;
}

export async function listarSessoes(cursoId) {
  const res = await api.get(`/cursos/${cursoId}/sessoes`);
  return res.data;
}

export async function criarSessao(cursoId, data) {
  const res = await api.post(`/cursos/${cursoId}/sessoes`, data);
  return res.data;
}

export async function atualizarSessao(id, data) {
  const res = await api.put(`/sessoes/${id}`, data);
  return res.data;
}

export async function deletarSessao(id) {
  const res = await api.delete(`/sessoes/${id}`);
  return res.data;
}

export async function listarMateriais(sessaoId) {
  const res = await api.get(`/sessoes/${sessaoId}/materiais`);
  return res.data;
}

export async function criarMaterial(sessaoId, data) {
  const res = await api.post(`/sessoes/${sessaoId}/materiais`, data);
  return res.data;
}

export async function atualizarMaterial(id, data) {
  const res = await api.put(`/materiais/${id}`, data);
  return res.data;
}

export async function deletarMaterial(id) {
  const res = await api.delete(`/materiais/${id}`);
  return res.data;
}

export async function listarInscricoes(cursoId) {
  const res = await api.get(`/cursos/${cursoId}/inscricoes`);
  return res.data;
}

export async function criarInscricao(cursoId, data) {
  const res = await api.post(`/cursos/${cursoId}/inscricoes`, data);
  return res.data;
}

export async function cancelarInscricao(id) {
  const res = await api.patch(`/inscricoes/${id}/cancelar`);
  return res.data;
}

export async function listarInscricoesMembro(membroId) {
  const res = await api.get(`/inscricoes/membro/${membroId}`);
  return res.data;
}

export async function listarPresencas(sessaoId) {
  const res = await api.get(`/sessoes/${sessaoId}/presencas`);
  return res.data;
}

export async function registrarPresencas(sessaoId, data) {
  const res = await api.post(`/sessoes/${sessaoId}/presencas`, data);
  return res.data;
}
